module.exports = __webpack_public_path__ + "static/assets/e8544a459ecdc7dd4bcbc36f8bb1c655.png";